import { useMemo } from "react";
import {
  ensureExhaustive,
  getRatingQualifierKey,
  RatingQualifierKey,
} from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useHomeCustomerReviews = (score: number) => {
  const { t } = useI18nContext();

  return useMemo(() => {
    const getRatingLabel = (): string => {
      const qualifierKey = getRatingQualifierKey(score);
      switch (qualifierKey) {
        case RatingQualifierKey.Exceptional:
          return t("core-hotels.shop.ratingDescription.exceptional");
        case RatingQualifierKey.Superb:
          return t("core-hotels.shop.ratingDescription.superb");
        case RatingQualifierKey.Excellent:
          return t("core-hotels.shop.ratingDescription.excellent");
        case RatingQualifierKey.VeryGood:
          return t("core-hotels.shop.ratingDescription.veryGood");
        case RatingQualifierKey.Good:
          return t("core-hotels.shop.ratingDescription.good");
        case RatingQualifierKey.Pleasant:
          return t("core-hotels.shop.ratingDescription.pleasant");
        case RatingQualifierKey.Satisfactory:
          return t("core-hotels.shop.ratingDescription.satisfactory");
        case RatingQualifierKey.Fair:
          return t("core-hotels.shop.ratingDescription.fair");
        case RatingQualifierKey.Adequate:
          return t("core-hotels.shop.ratingDescription.adequate");
        case RatingQualifierKey.Mediocre:
          return t("core-hotels.shop.ratingDescription.mediocre");
        case RatingQualifierKey.BelowAverage:
          return t("core-hotels.shop.ratingDescription.belowAverage");
        case RatingQualifierKey.Poor:
          return t("core-hotels.shop.ratingDescription.poor");
        case RatingQualifierKey.VeryPoor:
          return t("core-hotels.shop.ratingDescription.veryPoor");
        default:
          return ensureExhaustive(
            qualifierKey,
            t("core-hotels.shop.ratingDescription.veryPoor")
          );
      }
    };

    return {
      ratingLabel: getRatingLabel(),
    };
  }, [score, t]);
};
